
import { CUSTOM_ELEMENTS_SCHEMA, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';
registerLocaleData(localePt);

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

// Theme & Settings
import { fengTheme } from '../theme';
import { fengSettings } from '../settings';
import { fengEnv } from '../env';

// FengST
import { NgxFengSTUiModule } from '@fengbrasil/ngx-fengst-ui';
import { JwtInterceptor, NgxFengSTAuthModule } from '@fengbrasil/ngx-fengst-auth';
import { NgxFengSTLayoutModule } from '@fengbrasil/ngx-fengst-layout';
import { NgxFengSTAccountModule } from '@fengbrasil/ngx-fengst-account';
import { NgxFengstExclusiveContentModule } from '@fengbrasil/ngx-fengst-exclusive-content';
import { NgxFengSTContactModule } from '@fengbrasil/ngx-fengst-contact';
import { NgxFengSTPartnerModule } from '@fengbrasil/ngx-fengst-partner';

import { RecaptchaV3Module, RECAPTCHA_V3_SITE_KEY } from 'ng-recaptcha';
import { ActivatedRouteSnapshot } from '@angular/router';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { IPublicClientApplication, InteractionType, PublicClientApplication } from '@azure/msal-browser';
import { MSAL_GUARD_CONFIG, MSAL_INSTANCE, MsalBroadcastService, MsalGuard, MsalGuardConfiguration, MsalService } from '@azure/msal-angular';

/**
 * Here we pass the configuration parameters to create an MSAL instance.
 * For more info, visit: https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-angular/docs/v2-docs/configuration.md
 */
export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication(fengEnv.auth?.adb2c?.msalConfig);
}

/**
 * Set your default interaction type for MSALGuard here. If you have any
 * additional scopes you want the user to consent upon login, add them here as well.
 */
export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
  };
}
@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    RecaptchaV3Module,

    NgxFengSTUiModule.forRoot({'theme': fengTheme, 'settings': fengSettings, 'env': fengEnv}),
    NgxFengSTAuthModule.forRoot({'theme': fengTheme, 'settings': fengSettings, 'env': fengEnv}),
    NgxFengSTLayoutModule.forRoot({'theme': fengTheme, 'settings': fengSettings, 'env': fengEnv}),
    NgxFengSTAccountModule.forRoot({'theme': fengTheme, 'settings': fengSettings, 'env': fengEnv}),
    NgxFengstExclusiveContentModule.forRoot({'theme': fengTheme, 'settings': fengSettings, 'env': fengEnv}),
    NgxFengSTContactModule.forRoot({'theme': fengTheme, 'settings': fengSettings, 'env': fengEnv}),
    NgxFengSTPartnerModule.forRoot({'theme': fengTheme, 'settings': fengSettings, 'env': fengEnv}),
  ],
  providers: [
    {
      provide: LOCALE_ID,
      useValue: 'pt-BR',
    },
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useValue: fengEnv.recaptcha.key
    },
    { 
      provide: HTTP_INTERCEPTORS, 
      useClass: JwtInterceptor, 
      multi: true 
    },
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: MSALGuardConfigFactory
    },
    MsalService,
    MsalGuard,
    MsalBroadcastService,
  ],
  bootstrap: [AppComponent],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class AppModule { }
